import { FormattedMessage } from 'react-intl';

import { DateInput } from '../../../../forms/dateInput/index';
import messages from '../CompanyDetails.messages';

export const TradingFromQuestion = (props) => {
    const { onChange } = props;

    return (
        <DateInput
            label={<FormattedMessage {...messages.businessTrading} />}
            onChange={onChange}
            name="tradingFrom"
            id="tradingFrom"
        />
    );
};
